module.exports = __webpack_public_path__ + "static/media/nexaslim-1.be8160fa.png";